export const DISMISSIBLE_ALERTS_DISMISS = 'syftacp/DISMISSIBLE_ALERTS_DISMISS' as const
